.validation {
	display: flex;
	align-items: center;
	gap: 5px;
}

.validationImage {
	margin-top: 2px;
	width: 24px;
	height: 24px;
	flex-shrink: 0;
}
